import type { RunRecord } from './safeTypes'

const ACTIVE_KEY = 'events_run_active'
const LOCK_KEY = 'events_run_lock'
const RUN_KEY = (id: string) => `events_run_${id}`

// сколько хранить снапшот (например 24 часа)
const TTL_MS = 24 * 60 * 60 * 1000
// сколько живёт lock без обновления (например 5 минут)
const LOCK_STALE_MS = 5 * 60 * 1000

const isBrowser = () => typeof window !== 'undefined' && typeof localStorage !== 'undefined'

type StoredRun = { v: 1; savedAt: number; run: RunRecord }
type StoredLock = { runId: string; updatedAt: number }

export const setActiveRunIdLocal = (runId: string) => {
  if (!isBrowser()) return
  try { localStorage.setItem(ACTIVE_KEY, runId) } catch {}
}

export const clearActiveRunIdLocal = () => {
  if (!isBrowser()) return
  try { localStorage.removeItem(ACTIVE_KEY) } catch {}
}

export const snapshotRunLocal = (run: RunRecord) => {
  if (!isBrowser()) return
  const payload: StoredRun = { v: 1, savedAt: Date.now(), run }
  try { localStorage.setItem(RUN_KEY(run.runId), JSON.stringify(payload)) } catch {}
}

export const clearRunLocal = (runId: string) => {
  if (!isBrowser()) return
  try { localStorage.removeItem(RUN_KEY(runId)) } catch {}
}

export const loadRunLocal = (runId: string): RunRecord | null => {
  if (!isBrowser()) return null
  try {
    const raw = localStorage.getItem(RUN_KEY(runId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as StoredRun
    if (!parsed?.run || !parsed?.savedAt) return null
    if (Date.now() - parsed.savedAt > TTL_MS) {

      clearRunLocal(runId)
      return null
    }
    return parsed.run
  } catch {
    return null
  }
}

export const loadActiveRunLocal = (): RunRecord | null => {
  if (!isBrowser()) return null
  try {
    const runId = localStorage.getItem(ACTIVE_KEY)
    if (!runId) return null
    return loadRunLocal(runId)
  } catch {
    return null
  }
}


export const acquireRunLock = (runId: string): boolean => {
  if (!isBrowser()) return true
  try {
    const raw = localStorage.getItem(LOCK_KEY)
    if (!raw) {
      const lock: StoredLock = { runId, updatedAt: Date.now() }
      localStorage.setItem(LOCK_KEY, JSON.stringify(lock))
      return true
    }
    const lock = JSON.parse(raw) as StoredLock
    const isStale = !lock?.updatedAt || Date.now() - lock.updatedAt > LOCK_STALE_MS

    if (isStale) {
      const next: StoredLock = { runId, updatedAt: Date.now() }
      localStorage.setItem(LOCK_KEY, JSON.stringify(next))
      return true
    }

    if (lock.runId === runId) {
      const next: StoredLock = { runId, updatedAt: Date.now() }
      localStorage.setItem(LOCK_KEY, JSON.stringify(next))
      return true
    }

    return false
  } catch {
    return true
  }
}

export const touchRunLock = (runId: string) => {
  if (!isBrowser()) return
  try {
    const lock: StoredLock = { runId, updatedAt: Date.now() }
    localStorage.setItem(LOCK_KEY, JSON.stringify(lock))
  } catch {}
}

export const releaseRunLock = (runId: string) => {
  if (!isBrowser()) return
  try {
    const raw = localStorage.getItem(LOCK_KEY)
    if (!raw) return
    const lock = JSON.parse(raw) as StoredLock
    if (lock?.runId === runId) localStorage.removeItem(LOCK_KEY)
  } catch {}
}
